import React from "react";
import {
  Panel,
  PanelType,
  IPanelStyles,
} from "@fluentui/react/lib/Panel";
import {
  DefaultButton,
  getTheme,
  IconButton,
  PrimaryButton,
  Stack,
  IStackStyles,
  IButtonStyles, Dropdown
} from "@fluentui/react";
import GoBackToMainDialogBtn from "components/dialogs/addInventoryDialog/GoBackToMainDialogBtn";
import {dropdownStyles, filterPanelStyles as content} from "constants/styles";
import { useSelector, useDispatch } from "react-redux";
import { setInventoryFilters } from "store/inventory/inventory.action";
import { AppState } from "store";
import inventoryDropdownsValues from "constants/inventoryDropdownsValues";

const bodyStyleValues = inventoryDropdownsValues.bodyStyleValues.map((item) => {
  return { key: item, text: item };
});
const exteriorColorValues = inventoryDropdownsValues.exteriorColorValues.map((item) => {
  return { key: item, text: item };
});

const interiorColorValues = inventoryDropdownsValues.interiorColorValues.map((item) => {
  return { key: item, text: item };
});
const doorsValue = inventoryDropdownsValues.doorValues.map((item) => {
  return { key: item, text: item };
});



const contentStyles = content();
const theme = getTheme();
const panelStyles: Partial<IPanelStyles> = {
  commands: {
    marginTop: 0,
  },
};

const closeBtnStyles: IButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

const stackTokens = { childrenGap: 10 };

const stackStyles: IStackStyles = {
  root: {
    marginTop: 20,
  },
};

interface IProps {
  isOpen: boolean;
  label: string;
  onClose: () => void;
  cleanFilters: () => void;
  handleFilter: () => void;
}

const BodyAndColorPanel: React.FC<IProps> = ({
  isOpen,
  label,
  onClose,
  cleanFilters,
  handleFilter,
}) => {
  const filters = useSelector((state: AppState) => state.inventory.filters);
  const dispatch = useDispatch();

  const handleChange = (e, item) => {
    dispatch<any>(setInventoryFilters({
      ...filters, [e.target.id]: item.text
    }))
  }

  return (
    <Panel
      styles={panelStyles}
      type={PanelType.medium}
      isOpen={isOpen}
      onDismiss={onClose}
      hasCloseButton={false}
      onRenderHeader={() => (
        <div className={contentStyles.bottomShadow}>
          <Stack
            horizontal
            horizontalAlign="space-between"
            style={{ width: "100%" }}
          >
            <GoBackToMainDialogBtn label={label} onClick={onClose} />

            <div className={contentStyles.marginRight}>
              <IconButton
                styles={closeBtnStyles}
                iconProps={{ iconName: "Cancel" }}
                ariaLabel="Close popup modal"
                onClick={onClose}
              />
            </div>
          </Stack>
        </div>
      )}
      onRenderFooter={() => (
        <div className={contentStyles.footer}>
          <Stack horizontal horizontalAlign="space-between">
            <DefaultButton text="Clear" onClick={cleanFilters} />
            <PrimaryButton text="View results" onClick={handleFilter} />
          </Stack>
        </div>
      )}
    >
      <Stack tokens={stackTokens} styles={stackStyles}>
        <Dropdown
            id="body"
            label="Body Style"
            placeholder="any..."
            options={bodyStyleValues}
            styles={dropdownStyles}
            selectedKey={filters.body}
            onChange={handleChange}
        />
        <Dropdown
            id="exteriorColor"
            label="Exterior Color"
            placeholder="any..."
            options={exteriorColorValues}
            styles={dropdownStyles}
            selectedKey={filters.exteriorColor}
            onChange={handleChange}
        />
        <Dropdown
            id="intColorGeneric"
            label="Interior Color"
            placeholder=""
            options={interiorColorValues}
            styles={dropdownStyles}
            selectedKey={filters.intColorGeneric}
            onChange={handleChange}
        />
        <Dropdown
            id="doors"
            placeholder=""
            options={doorsValue}
            styles={dropdownStyles}
            label="Doors"
            selectedKey={filters.doors}
            onChange={handleChange}
        />
      </Stack>
    </Panel>
  );
};

export default BodyAndColorPanel;
